var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-cloud"},_vm._l((_vm.tags),function(tag){return _c('span',{key:tag.text,staticClass:"tag",class:tag.weight || 'low'},[_vm._v(_vm._s(tag.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }